import React from 'react';
import { DatesType } from '../Types';
import { calendarConfig } from 'Components/Constants';
import { Calendar, HeaderBlock } from 'Components/Calendar/CalendarComponents';
import { DateBlock } from 'Components/Calendar/DateBlock';
import { ConvertToPounds } from 'Components/Functions';
import Loader from 'Components/Loader';

type DatesCalendarProps = {
    days: DatesType[][];
    datesLoading: boolean;
    addDate: (newDate: string) => void;
}

function DatesCalendar({ days, datesLoading, addDate }: DatesCalendarProps) {

    return (
        <Calendar>
            <thead>
                <tr>
                    <HeaderBlock>Mon</HeaderBlock>
                    <HeaderBlock>Tues</HeaderBlock>
                    <HeaderBlock>Wed</HeaderBlock>
                    <HeaderBlock>Thurs</HeaderBlock>
                    <HeaderBlock>Fri</HeaderBlock>
                    {calendarConfig.includeWeekends &&
                        <>
                            <HeaderBlock>Sat</HeaderBlock>
                            <HeaderBlock>Sun</HeaderBlock>
                        </>
                    }
                </tr>
            </thead>
            <tbody>
                {/*}Loop through all row arrays{*/}
                {datesLoading ? 
                        <td colSpan={calendarConfig.includeWeekends ? 7 : 5} style={{height: "25em"}}>
                            <Loader/>
                        </td>:
                    days.map((dayRow: DatesType[], index:number) => {
                        return (
                            <tr key={index}>
                                {/*}Return all date objects for row array{*/}
                                {dayRow && dayRow.map((day: DatesType) => {
                                    return (
                                        <DateBlock
                                            $visible={day.visible}
                                            $available={day.available}
                                            $selectable={day.selectable}
                                            $selected={day.selected}
                                            $bankHoliday={day.bankHoliday}
                                            $bookedCollection={day.bookedCollection}
                                            $bookedReturn={day.bookedReturn}
                                            $isCollection={day.isCollection}
                                            $isReturn={day.isReturn}
                                            onClick={() => !day.bankHoliday && day.selectable && day.available && addDate(day.date)}
                                        >
                                            {day.visible && day.dateString}
                                            <br/>{day.visible && calendarConfig.showDailyPrices && ConvertToPounds(day.price)}
                                        </DateBlock>
                                    );
                                })}
                            </tr>
                        );
                    })
                }
            </tbody>
        </Calendar>
    );
}
export default DatesCalendar;
